import { Component, computed, inject } from "@angular/core";
import { ButtonModule } from "@progress/kendo-angular-buttons";
import { DialogModule } from "@progress/kendo-angular-dialog";
import { DeactivateDialogService } from "./deactivate-dialog.service";

@Component({
    selector: 'cs-deactivate-dialog',
    imports: [
        DialogModule, ButtonModule
    ],
    templateUrl: './deactivate-dialog.component.html'
})
export class DeactivateDialogComponent {
  readonly dialogService = inject(DeactivateDialogService);

  isLoading = this.dialogService.isLoading;
  visible = this.dialogService.showDialog;
  title = this.dialogService.title;
  content = this.dialogService.content;
  continueText = this.dialogService.continueBtnText;
  cancelText = this.dialogService.cancelBtnText;
  deactivating = this.dialogService.isDeactivating;

  classList = computed<string>(() => {
    return `w-full rounded border text-white ${this.deactivating() ? 'bg-[#DC3545] border-[#DC3545]' : 'bg-black border-black'}`;
  });
}
